import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Category } from "../interfaces/home_entity";
import { availableIcons } from "../utils/icons";
import "./SubNavbar.css";

interface SubNavbarProps {
  categories: Category[];
}

const SubNavbar: React.FC<SubNavbarProps> = ({ categories }) => {
  const [openParentId, setOpenParentId] = useState<string | null>(null);
  const iconMap = new Map<string, React.ComponentType<any>>(
    availableIcons.map(icon => [icon.name, icon.component as React.ComponentType<any>])
  );

  const parentCategories = categories.filter(
    (cat) => !cat.parentCategoryId || cat.parentCategoryId === ""
  );

  const childCategoriesMap = categories.reduce<Record<string, Category[]>>((acc, cat) => {
    if (cat.parentCategoryId) {
      const key = String(cat.parentCategoryId);
      if (!acc[key]) acc[key] = [];
      acc[key].push(cat);
    }
    return acc;
  }, {});

  const renderIcon = (iconName?: string | null) => {
    if (!iconName) return <span className="subnavbar__icon">📂</span>;
    const Icon = iconMap.get(iconName);
    return Icon ? <Icon className="subnavbar__icon" /> : <span className="subnavbar__icon">📂</span>;
  };

  const handleToggle = (parentId: string) => {
    setOpenParentId(prev => (prev === parentId ? null : parentId));
  };

  return (
    <nav className="subnavbar">
      <div className="subnavbar__container">
        <ul className="subnavbar__list">
          {parentCategories.map((parent) => (
            <li key={parent.id} className="subnavbar__item">
              <div
                className="subnavbar__link"
                onClick={() => handleToggle(parent.id)}
              >
                {renderIcon((parent as any).icon)}
                <span className="subnavbar__text">{parent.name}</span>
              </div>

              {childCategoriesMap[parent.id] && (
                <ul
                  className={`subnavbar__dropdown ${
                    openParentId === parent.id ? "open" : ""
                  }`}
                >
                  {childCategoriesMap[parent.id].map((child) => (
                    <li key={child.id} className="subnavbar__subitem">
                      <Link
                        to={`/category/${child.id}`}
                        className="subnavbar__sublink"
                        onClick={() => setOpenParentId(null)} // close dropdown on selection
                      >
                        {renderIcon((child as any).icon)}
                        <span className="subnavbar__text">{child.name}</span>
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};
export default SubNavbar;
